import React, { useState } from "react";
import {
  Typography,
  useMediaQuery,
  Link,
  Stack,
  Button,
  Box,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { parseEther } from "@ethersproject/units";
import { ETH_VAL } from "../constants";
import MemberWhiteList from "./member_whitelist.json";

const MintTextStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "15px",
  fontFamily: "Helvetica",
  textAlign: "center",
  marginTop: "7px",
}));

export default function MintButton({
  address,
  userSigner,
  localProvider,
  mainnetProvider,
  price,
  web3Modal,
  loadWeb3Modal,
  logoutOfWeb3Modal,
  blockExplorer,
  contract,
  remainTokenCount,
  remainMintCount,
  saleStatus,
}) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  const [amount, setAmount] = useState(ETH_VAL);
  const [minting, setMinting] = useState(false);
  const [mintCount, setMintCount] = useState(1);

  const _decreaseMintCount = () => {
    if (mintCount === 1) return;
    setMintCount(mintCount - 1);
  };

  const _increaseMintCount = () => {
    if (remainMintCount < 1) {
      setMintCount(1);
      return;
    }
    if (mintCount >= remainMintCount) {
      setMintCount(remainMintCount);
      return;
    }
    setMintCount(mintCount + 1);
  };

  const notify = (message) => toast(message);

  const mintNftHandler = async () => {
    if (!web3Modal || !web3Modal.cachedProvider) {
      alert("Please check your wallet connection");
      return;
    }
    if (!MemberWhiteList.addresses.includes(address) && saleStatus === 1) {
      notify("You are not whitelisted.");
      return;
    }
    if (remainMintCount < 1) return;
    setMinting(true);
    try {
      const mintFunction = contract.connect(userSigner)["mint"];
      const hash = await mintFunction(address, mintCount, {
        value: parseEther((amount * mintCount).toString()),
      });
      const result = await hash.wait();
      console.log(result);
      setMinting(false);
      notify(mintCount + " NFT(s) minted.");
    } catch (e) {
      console.log(e);
      var errormsg = e.message ? e.message : "Mint Failed.";
      if (errormsg.indexOf("insufficient funds") !== -1)
        errormsg = "Insufficient funds";
      if (errormsg.indexOf("whitelisted") !== -1)
        errormsg = "User is not whitelisted";
      if (errormsg.indexOf("Mint is paused") !== -1)
        errormsg = "Mint is paused";
      if (errormsg.indexOf("Recipient should be present") !== -1)
        errormsg = "Recipient should be present";
      if (errormsg.indexOf("Need to mint at least 1 NFT") !== -1)
        errormsg = "Need to mint at least 1 NFT";
      if (errormsg.indexOf("Royalty value should be positive") !== -1)
        errormsg = "Royalty value should be positive";
      if (errormsg.indexOf("Max mint amount per session exceeded") !== -1)
        errormsg = "Max mint amount per session exceeded";
      notify(errormsg);
      setMinting(false);
    }
  };

  return (
    <Stack>
      <Button
        variant="contained"
        onClick={mintNftHandler}
        sx={{
          borderRadius: "50px",
          bgcolor: "#B6E094",
          color: "#000",
          p: "5px 60px",
          boxShadow: "unset",
          fontSize: "20px",
        }}
      >
        {minting ? <>MINTING ...</> : <>MINT&nbsp;NOW</>}
      </Button>
      <MintTextStyle>{9999 - remainTokenCount}/9999 minted</MintTextStyle>
    </Stack>
  );
}
